<template>
  <div class="attent">
    <user-info :userInfo="userInfo" :isShowFansBar="false" />
    <div class="content-bg">
      <h3>我的关注（{{ userInfo.followings_count }}）</h3>
      <van-list
        class="vant-list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="item"
          v-for="(item, index) in followers"
          :key="item.id"
          @click="userItemClick(item)"
        >
          <van-image round class="avatar" fit="cover" :src="item.headimgurl" />
          <div class="info">
            <div class="name">{{ item.nickname }}</div>
            <div class="sign">等级：{{ item.level_msg }}</div>
          </div>
          <div class="follow" @click="followClick(index)">
            {{ getIsFollow(index) }}
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import UserInfo from "./child/UserInfo";
import { getFollowing } from "network/profile";
import { userFollow, userUnFollow } from "network/home";
import qs from "qs";
export default {
  name: "Attent",
  components: {
    UserInfo,
  },
  data() {
    return {
      userInfo: {},
      currentIndex: 0,
      followers: [],
      page: 0,
      loading: false,
      finished: false,
    };
  },
  computed: {
    getIsFollow() {
      return (index) => {
        console.log(index);
        return this.followers[index].is_followed ? "已关注" : "+关注";
      };
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  mounted() {},
  methods: {
    //关注或取消关注
    followClick(index) {
      let params = { user_id: this.followers[index].id };
      if (this.followers[index].is_followed) {
        userUnFollow(qs.stringify(params)).then((res) => {
          this.followers[index].is_followed = !this.followers[index]
            .is_followed;
        });
      } else {
        userFollow(qs.stringify(params)).then((res) => {
          this.followers[index].is_followed = !this.followers[index]
            .is_followed;
        });
      }
    },
    //点击关注的用户
    userItemClick(item) {
      this.$router.push({
        path: "/profileuser",
        query: {
          id: item.id,
        },
      });
    },
    //加载更多
    onLoad() {
      this.page++;
      this.getFollow();
    },
    /**
     * 请求
     */
    //关注列表
    getFollow() {
      getFollowing(this.userInfo.id, this.page).then((res) => {
        this.followers = this.followers.concat(res.data);
        if (res.data.length < 20) {
          this.finished = true;
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.attent {
  background: #f5f5f5;
  min-height: 100vh;
}
.content-bg {
  margin: 20px 15px 0px 15px;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}
.content-bg h3 {
  font-size: 14px;
}
.vant-list {
  margin-top: 10px;
  min-height: 340px;
}
.item {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
.avatar {
  width: 40px;
  height: 40px;
  border: 1px solid #707070;
}
.info {
  flex: 1;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.info .name {
  font-size: 14px;
  color: #232323;
}
.info .sign {
  flex: 1;
  font-size: 12px;
  color: #707070;
}
.follow {
  margin-right: 5px;
  width: 60px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 5px;
  background-color: var(--color-main);
  font-size: 14px;
  color: #fff;
}
</style>